export const NEW_LINE_REGEX = /\\n/g;
export const ESCAPE_NUMBERS_REGEX = /(^|\n)(\d+)\.(\s|$)/g;
